import { DataTableFeatures } from "@/types/dataTableSettings";
import { useContext } from "react";
import { DataTableSettingsContext } from "../DataTableSettingsContext";

export const useDataTableFeatures = (): DataTableFeatures => {
  const settings = useContext(DataTableSettingsContext);
  return settings?.features ?? {};
};
